import $ from 'jquery/dist/jquery';
window.$ = $;



//////////////////
// WEBPACK FOOTER
// ./src/js/components/global/global-jquery.js
// module id = 3
// module chunks = 0